import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';
import { shareToWithText } from 'lib/share';

import SOCIAL_MEDIA from 'constants/socialMedia';

const SHAREABLE_SOCIAL_MEDIA = [
  {
    name: SOCIAL_MEDIA.FACEBOOK.TITLE,
    icon: <Icon name="facebook" />,
  },
  {
    name: SOCIAL_MEDIA.TWITTER.TITLE,
    icon: <Icon name="twitter" />,
  },
  {
    name: SOCIAL_MEDIA.WHATSAPP.TITLE,
    icon: <Icon name="whatsapp-filled" />,
  },
  {
    name: SOCIAL_MEDIA.TELEGRAM.TITLE,
    icon: <Icon name="telegram" />,
  },
  { name: SOCIAL_MEDIA.EMAIL.TITLE, icon: <Icon name="email" /> },
];

const SocialMediaShare = ({ gaEventCategory, threadTitle }) => (
  <div className="mt-2 flex w-full items-center md:mt-0 md:w-fit">
    <Text className="mr-2" size="size1">
      Compartilhe:
    </Text>
    <div className="flex gap-x-2">
      {SHAREABLE_SOCIAL_MEDIA.map(({ icon, name }) => (
        <Button
          key={name}
          aria-label={`Compartilhe no ${name}`}
          icon={icon}
          size="size3"
          type="secondary-stroke"
          onClick={() => {
            sendEvent({
              action: `share_${name.toLowerCase()}`,
              category: gaEventCategory,
              data: name.toLowerCase(),
            });
            shareToWithText(name, threadTitle);
          }}
        />
      ))}
    </div>
  </div>
);

SocialMediaShare.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  threadTitle: PropTypes.string.isRequired,
};

export default SocialMediaShare;
